import React from 'react';
import PropTypes from 'prop-types';

import { isMobileUA } from 'dpl/shared/utils';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';
import useNotificationCounts from 'dpl/shared/hooks/useNotificationCounts';
import UserHeaderLoggedInDropdown from 'dpl/components/Header/UserHeaderLoggedInDropdown';
import GlobalMobileMenuNavigationButtonContainer from 'dpl/containers/GlobalMobileMenu/GlobalMobileMenuNavigationButtonContainer';
import UserHeaderLoggedOutV2 from 'dpl/auth/components/UserHeaderLoggedOutV2';

const IS_MOBILE_UA = isMobileUA();

/** @param {Record<string, any>} props */
export default function UserHeaderActionsContainer({
  isLoggedIn = null,
  ...rest
}) {
  const props = { isLoggedIn, ...rest };
  const currentUser = useCurrentUser();
  const notificationCounts = useNotificationCounts();

  const allProps = {
    currentUser,
    ...notificationCounts,
    ...props
  };

  if (IS_MOBILE_UA) {
    return <GlobalMobileMenuNavigationButtonContainer {...allProps} />;
  }

  if (currentUser.isLoggedIn) {
    return <UserHeaderLoggedInDropdown {...allProps} />;
  }

  if (currentUser.isLoggedIn === false) {
    return <UserHeaderLoggedOutV2 />;
  }

  return null;
}

UserHeaderActionsContainer.propTypes = {
  isLoggedIn: PropTypes.bool
};
